exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1fwfOVHG3WRTuF{min-height:50px;position:relative}._1fwfOVHG3WRTuF ._5SD7d5D80GYUoF{display:flex;margin-left:72px}._1fwfOVHG3WRTuF ._5SD7d5D80GYUoF button{margin:auto}.m0tVQH8GA9O8zK{display:flex;align-items:center}._1PNtqBHmvRooNe{object-fit:cover;position:absolute;height:100%;top:0;pointer-events:none}._1e4EiSPf9jLLUr{width:300px;left:0}._2Isk82vqUHlhrk{width:500px;right:0}._3qP_JpwL6um86M{display:flex;justify-content:center;align-items:center}._2HGqb71oYP5Hu1{color:#172b4d;font-size:14px;font-weight:400;line-height:20px;display:flex;max-width:90ch;margin:0}._2HGqb71oYP5Hu1 p{margin-top:8px}._5SD7d5D80GYUoF{flex:1}._5SD7d5D80GYUoF button{margin:0 0 0 24px}@media only screen and (max-width:1000px){._1fwfOVHG3WRTuF{background-position-x:-128px;padding-left:192px}._1e4EiSPf9jLLUr{left:-148px}}@media only screen and (max-width:800px){._1fwfOVHG3WRTuF{padding-left:26px}._1e4EiSPf9jLLUr{display:none}._2HGqb71oYP5Hu1{padding-right:0}}@media only screen and (max-width:600px){._2-ZUsl5Xs5L75z{margin-right:0}}", ""]);

// exports
exports.locals = {
	"banner": "_1fwfOVHG3WRTuF",
	"controls": "_5SD7d5D80GYUoF",
	"automaticOnboardingMsg": "m0tVQH8GA9O8zK",
	"waveImg": "_1PNtqBHmvRooNe",
	"leftWaveImg": "_1e4EiSPf9jLLUr",
	"rightWaveImg": "_2Isk82vqUHlhrk",
	"container": "_3qP_JpwL6um86M",
	"body": "_2HGqb71oYP5Hu1",
	"content": "_2-ZUsl5Xs5L75z"
};